export const VIEW_TEMPLATE_MODE = 'view';
export const EDIT_TEMPLATE_MODE = 'edit';
export const APPLY_TEMPLATE_MODE = 'apply';
export const CREATE_TEMPLATE_MODE = 'create';

export const TEMPLATE_MODES = [
  VIEW_TEMPLATE_MODE,
  EDIT_TEMPLATE_MODE,
  APPLY_TEMPLATE_MODE,
  CREATE_TEMPLATE_MODE,
];
